import { createFileRoute, redirect } from '@tanstack/react-router';
import { landingFor, recallOrganization } from '@/app/workspaces/workspaces';
import { myOrganizationsQuery } from '@/features/organizer/api';
import { isAdmin, session } from '@/lib/auth/session';

export const Route = createFileRoute('/_authed/')({
  beforeLoad: async ({ context: { queryClient } }) => {
    const current = session.get();
    const organizations = isAdmin(current)
      ? []
      : await queryClient.ensureQueryData(myOrganizationsQuery());
    throw redirect({ href: landingFor(current, organizations, recallOrganization(current)) });
  },
});
